import React, { useState } from "react";
import Axios from "axios";
import PostCard from "./PostCard";
import PostBuilder from "./PostBuilder";

const Posts = () => {
  const [posts, setPosts] = useState([]);
  Axios.get("https://fitness-junction-bots.onrender.com/api/getposts")
    .then((data) => {
      setPosts(data.data.posts);
    })
    .catch((error) => console.log(error));

  return (
    <div className="container-fluid postscomp">
      <h2 className="fw-medium">Latest Posts</h2>
      <div className="row">
        {posts.map((post) => (
          <div className="col-sm-4 postcardcss" key={post.postId}>
            <PostCard
              userName={post.userName}
              postId={post.postId}
              postTitle={post.postTitle}
            />
          </div>
        ))}
      </div>

      <PostBuilder />
    </div>
  );
};

export default Posts;
